import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './BrandLoyalty.module.css'

interface BrandLoyaltyCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function BrandLoyaltyCard({ score = 0, maxScore = 0, status = 'MAXIMO' }: BrandLoyaltyCardProps) {


    const setMessage = () => {
        if (status === 'MAXIMO') {
            return (
                <div className='margin-top-20'>
                    Você é um cliente Top! Fidelidade <span className='text-bold'>maximizada</span>.
                </div>
            )
        } else if (status === 'EM_PROGRESSO') {
            return (
                <div className='margin-top-20'>
                    <div><span className='text-bold'>Mantenha o contrato ativo</span> para aumentar a pontuação.</div>
                </div>
            )
        } else if (status === 'BLOQUEADO') {
            return (
                <div className='margin-top-20'>
                    <div>Pontuação desbloqueada a partir do <span className='text-bold'>3º mês</span> de contrato.</div>
                </div>
            )
        } else {
            return (
                <div className='margin-top-20'>
                    <div>Volte à um plano e transforme cada viagem em progresso e conquistas!</div>
                </div>
            )
        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Fidelidade com a Marca</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                <div style={{ fontSize: 40 }}>
                                    <span className={styles["current-score"]}>{score}</span>
                                    <span className={styles["total-score"]}>/ {maxScore}</span>
                                </div>
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}